import {
  validateAccountNumber,
  validatePhone,
} from '../../../../util/form-validation';
import { OutageLookUpType } from '../../../../__generated__/pge-types';
import { convertValidationRules } from '../../../../hooks/useFormState';
import { BaseValidationContext } from '../../../../hooks/useFormState.types';
import { useTranslation } from '../../../../hooks/useTranslation';

const { t } = useTranslation();

export type Model = {
  lookUpType: OutageLookUpType | undefined;
  lookUpPhoneNumber: string;
  lookUpAccountNumber: string;
};

async function validateLookUpParams(
  value: string,
  context: BaseValidationContext<Model>,
) {
  const error =
    context.values.lookUpType === OutageLookUpType.Phone
      ? validatePhone(value)
      : validateAccountNumber(value);

  if (error !== null) {
    return error;
  }
}

export default convertValidationRules<Model>(context => {
  const { lookUpType } = context.values;
  return {
    lookUpAccountNumber:
      lookUpType === OutageLookUpType.Account ? validateLookUpParams : null,
    lookUpPhoneNumber:
      lookUpType === OutageLookUpType.Phone ? validateLookUpParams : null,
  };
});
